import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import { isFieldForListingType } from '../../util/fieldHelpers';

import { Heading } from '../../components';

import css from './ListingPage.module.css';

const SectionExpiryMaybe = props => {
  const { publicData, intl } = props;

  if (!publicData) {
    return null;
  }

  const { validFromDate, expiryDate } = publicData;

  return (
    <section className={css.sectionDetails}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        <FormattedMessage id="ListingPage.expiryDatesTitle" />
      </Heading>
        { validFromDate ? (
          <div className={css.detailsRow}>
            <span className={css.detailLabel}>
              <FormattedMessage id="ListingPage.expiryDatesFromLabel" />
            </span>
            &nbsp;:&nbsp;
            <span>{validFromDate}</span>
          </div>
        ) : null }
        { expiryDate ? (
          <div className={css.detailsRow}>
            <span className={css.detailLabel}>
              <FormattedMessage id="ListingPage.expiryDatesTillLabel" />
            </span>
            &nbsp;:&nbsp;
            <span>{expiryDate}</span>
          </div>
        ) : null }
    </section>
  );
};

export default SectionExpiryMaybe;
